import { create } from "zustand";
import { DialogActions, DialogConfig, DialogState } from "./types";

export const useDialogStore = create<DialogState & DialogActions>(set => ({
  dialogs: {},

  openDialog: (config: DialogConfig) =>
    set(state => ({
      dialogs: {
        ...state.dialogs,
        [config.key]: config,
      },
    })),

  // A dialog can be gone by the time its confirmation finishes (closed with
  // its X, or by a Booking page moving on). Writing its key back as
  // `undefined` would break every dialog rendered afterwards.
  closeDialog: (key: string) =>
    set(state =>
      state.dialogs[key]
        ? {
            dialogs: {
              ...state.dialogs,
              [key]: { ...state.dialogs[key], closing: true },
            },
          }
        : state,
    ),

  removeDialog: (key: string) =>
    set(state => {
      const { [key]: _, ...rest } = state.dialogs;
      return { dialogs: rest };
    }),

  closeAllDialogs: () =>
    set(state => {
      const closingDialogs = Object.keys(state.dialogs).reduce(
        (acc, key) => ({
          ...acc,
          [key]: { ...state.dialogs[key], closing: true },
        }),
        {},
      );
      return { dialogs: closingDialogs };
    }),

  isDialogOpen: (key: string): boolean => {
    const state = useDialogStore.getState();
    return !!state.dialogs[key];
  },

  setDialogConfirming: (key: string, confirming: boolean) =>
    set(state =>
      state.dialogs[key]
        ? {
            dialogs: {
              ...state.dialogs,
              [key]: { ...state.dialogs[key], confirming },
            },
          }
        : state,
    ),
}));
